import { render } from "./ChatListView.vue?vue&type=template&id=79496499&scoped=true&ts=true"
import script from "./ChatListView.vue?vue&type=script&lang=ts"
export * from "./ChatListView.vue?vue&type=script&lang=ts"

import "./ChatListView.vue?vue&type=style&index=0&id=79496499&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79496499"]])

export default __exports__